






import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, NewObjectLocatableMixin } from "./mixins";
import DirectiveLinePropertyEditor from "./DirectiveLinePropertyEditor.vue";

@Component({
  components: {
    propertyEditor: DirectiveLinePropertyEditor,
  },
})
export default class NewArrowLinePropertyEditor extends Mixins(PropertyEditableMixin, NewObjectLocatableMixin) {
  async created(): Promise<void> {
    this.editingSource = await this.createSource();
    this.process = this.layoutLinear;
  }
}
